module.exports = __webpack_public_path__ + "static/media/YF08_1.68d3a247.jpg";